import styled from 'styled-components';

export const CardContainer = styled.div`
  display: grid;
`;

export const CardLink = styled.a`
  display: grid;
`;
